import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useLoad} from "../../context";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import Utils from "../../services/serviceUtils";
import "./index.css";
import { toast } from "react-toastify";

export default function FaleConoscoDeslogado() {
  const {load, setLoad} = useLoad();
  const [fale, setFale] = useState({
    nome: "",
    cpfCnpj: "",
    telefoneCelular: "",
    email: "",
    faleConoscoAssuntoId: "",
    mensagem: "",
  });
  const [assunto, setAssunto] = useState([]);
  const [jaEnviado, setJaEnviado] = useState(false);
  const [alertaCampo, setAlertaCampo] = useState({
    nome: "⠀",
    cpfCnpj: "⠀",
    telefoneCelular: "⠀",
    email: "⠀",
    assunto: "⠀",
    mensagem: "⠀",
  });
  async function fnAssunto() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faleconosco/assunto");
      setAssunto(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnEnviarFale() {
    try {
      if (jaEnviado) {
        return;
      }
      setJaEnviado(true);
      setLoad(true);
      let response = await ApiServices.apiPost("faleconosco/criar-anonimo", fale);
      if(response.statusCode == 200){
        toast.success(response.data)
        setJaEnviado(false);
        setFale({
          nome: "",
          cpfCnpj: "",
          telefoneCelular: "",
          email: "",
          faleConoscoAssuntoId: "",
          mensagem: "",
        })
      } else {
        toast.error(response.message)
        setJaEnviado(false);
      
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  function validar() {
    if (
      Mask.unMask(fale.nome).length > 0 &&
      Utils.valida_cpf_cnpj(fale.cpfCnpj) == true &&
      Mask.unMask(fale.telefoneCelular).length >= 10 &&
      fale.email.includes("@") == true &&
      Mask.unMask(fale.faleConoscoAssuntoId) != "" &&
      Mask.unMask(fale.mensagem).length > 0
    ) {
      fnEnviarFale();
    }

    if (Mask.unMask(fale.nome).length < 1) {
      setAlertaCampo((prev) => ({
        ...prev,
        nome: "Nome inválido",
      }));
    }

    if (Utils.valida_cpf_cnpj(fale.cpfCnpj) == false) {
      setAlertaCampo((prev) => ({...prev, cpfCnpj: "CPF ou CNPJ invalido"}));
    }

    if (Mask.unMask(fale.telefoneCelular).length < 10) {
      setAlertaCampo((prev) => ({
        ...prev,
        telefoneCelular: "Número de celular inválido",
      }));
    }
    if (fale.email.includes("@") == false) {
      setAlertaCampo((prev) => ({...prev, email: "E-mail invalido"}));
    }
    if (Mask.unMask(fale.faleConoscoAssuntoId) == "") {
      setAlertaCampo((prev) => ({
        ...prev,
        assunto: "Selecione um assunto",
      }));
    }
    if (Mask.unMask(fale.mensagem).length < 1) {
      setAlertaCampo((prev) => ({
        ...prev,
         mensagem: "O campo mensagem esta vázio",
      }));
    } 
  }
 
  useEffect(() => {
    fnAssunto();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className="d-flex justify-content-center">
        <div className="container">
          <div className="row pt-5">
            <h2>Fale conosco</h2>
            <div className="col-md-6 mt-3">
              <TextField
                fullWidth
                label="Nome"
                value={fale.nome}
                onChange={(e) => {
                  setFale((prev) => ({...prev, nome: e.target.value}));
                  setAlertaCampo((prev) => ({...prev, nome: "⠀"}));
                }}
              />
              <div style={{color: "red", fontWeight: 700, fontSize: 12}}>{alertaCampo.nome}</div>
            </div>
            <div className="col-md-3 mt-3">
              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                label="CPF / CNPJ"
                value={Mask.cpfCnpj(fale.cpfCnpj)}
                onChange={(e) => {
                  setFale((prev) => ({...prev, cpfCnpj: Mask.unMask(e.target.value)}));
                  setAlertaCampo((prev) => ({...prev, cpfCnpj: "⠀"}));
                }}
              />
              <div style={{color: "red", fontWeight: 700, fontSize: 12}}>{alertaCampo.cpfCnpj}</div>
            </div>
            <div className="col-md-3 mt-3">
              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                label="Celular"
                value={Mask.cel(fale.telefoneCelular)}
                onChange={(e) => {
                  setFale((prev) => ({...prev, telefoneCelular: e.target.value}));
                  setAlertaCampo((prev) => ({...prev, telefoneCelular: "⠀"}));
                }}
              />
              <div style={{color: "red", fontWeight: 700, fontSize: 12}}>
                {alertaCampo.telefoneCelular}
              </div>
            </div>
            <div className="row ">
              <div className="col-md-6  mt-3">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  fullWidth
                  label="E-mail"
                  value={fale.email}
                  onChange={(e) => {
                    setFale((prev) => ({...prev, email: e.target.value}));
                    setAlertaCampo((prev) => ({...prev, email: "⠀"}));
                  }}
                />
                <div style={{color: "red", fontWeight: 700, fontSize: 12}}>{alertaCampo.email}</div>
              </div>

              <div className="col-md-6  mt-3">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Assunto</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Assunto"
                    value={fale.faleConoscoAssuntoId}
                    onChange={(e) => {
                      setFale((prev) => ({...prev, faleConoscoAssuntoId: e.target.value}));
                      setAlertaCampo((prev) => ({...prev, assunto: "⠀"}));
                    }}>
                    {assunto.map((e) => (
                      <MenuItem key={e.faleConoscoAssuntoId} value={e.faleConoscoAssuntoId}>
                        {e.descricao}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div style={{color: "red", fontWeight: 700, fontSize: 12}}>
                  {alertaCampo.assunto}
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              <div className="clo-12 mt-3">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Digite sua mensagem"
                  multiline
                  rows={10}
                  variant="outlined"
                  value={fale.mensagem}
                  onChange={(e) => {
                    setFale((prev) => ({...prev, mensagem: e.target.value}));
                    setAlertaCampo((prev) => ({...prev, mensagem: "⠀"}));
                  }}
                />
                <div style={{color: "red", fontWeight: 700, fontSize: 12}}>{alertaCampo.mensagem}</div>
              </div>
              <div className="col-md-3 m-5">
                <button className="btn btn-warning py-3" onClick={validar}>
                  ENVIAR
                </button>
              </div>
            </div>
            <span className="text-center p-5">
              Para maiores informações entre em contato com a nossa Central de Atendimento Amigo Leo
              pelo telefone 0800 591 0127 ou pelo e-mail atendimento.amigoleo@leomadeiras.com.br.
              Nosso atendimento é feito de segunda à sexta-feira, das 09h00 às 18h00.
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
